function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconFoodDinnerFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 7.1c0-.606.494-1.1 1.1-1.1h4.4c.606 0 1.1.494 1.1 1.1 0 .606-.494 1.1-1.1 1.1h-1.1v1.262c6.706.563 12 6.186 12 13.038 0 .606-.494 1.1-1.1 1.1-.606 0-1.1-.494-1.1-1.1 0-6.012-4.888-10.9-10.9-10.9-6.012 0-10.9 4.888-10.9 10.9 0 .606-.494 1.1-1.1 1.1-.606 0-1.1-.494-1.1-1.1 0-6.852 5.294-12.475 12-13.038V8.2h-1.1c-.606 0-1.1-.494-1.1-1.1zm4.395 5.91h.014l.05.01a10.732 10.732 0 017.118 5.142l.003.005c.294.523.12 1.192-.406 1.499l-.007.004a1.105 1.105 0 01-1.497-.403l-.003-.005a8.525 8.525 0 00-5.655-4.086 1.101 1.101 0 01.383-2.166zM2 25.9c0-.606.494-1.1 1.1-1.1h26.8c.606 0 1.1.494 1.1 1.1 0 .606-.494 1.1-1.1 1.1H3.1c-.606 0-1.1-.494-1.1-1.1z",
    fill: props.color
  }));
}

export default SvgIconFoodDinnerFilled;